import { Component, Prop } from 'vue-property-decorator';
import ClaustroRegistro from '@/entities/snp/solicitud/posgrado/claustro/claustro-registro.vue';
import ClaustroListado from '@/entities/snp/solicitud/posgrado/claustro/claustro-listado.vue';
import ApeironComponent from '@/components/commons/apeiron-component.model';
import { Solucion } from '@/shared/model/solucion.model';
import { Solicitud } from '@/shared/model/solicitud.model';

@Component({
  components: {
    claustroRegistro: ClaustroRegistro,
    claustroListado: ClaustroListado,
  },
})
export default class ClaustroComponent extends ApeironComponent {
  @Prop({ required: true })
  public solucion: Solucion;

  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public permisos: any;

  @Prop({ required: true })
  public formModel: any;

  public toggleActualizarTabla = false;
  public mostrarRegistro = false;
  public mostrarListado = true;

  public actualizarTabla(): void {
    this.toggleActualizarTabla = !this.toggleActualizarTabla;
    this.mostrarRegistro = false;
    this.mostrarListado = true;
  }

  /**
   * Indicador para permitir el modo escritura
   */
  get esEscritura(): boolean {
    return this.esEscrituraConEstadoEnCaptura(this.solicitud.estado);
  }
}
